import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  AddLeadApi,
  BookingDetailApi,
  BookingUpdateApi,
  EditProfileApi,
  LoginApi,
  OTPVerificationApi,
  UserDetailApi,
  allBookingsListApi,
  allPropertiesApi,
  bookInspectionApi,
  getAllPackagesListApi,
  logoutApi,
} from "../api/setting";

const initialState = {
  userDetail: 0,
  getAllPackagesList: {},
  allBookingsList: {},
  allProperties: {},
  BookingDetail: {},
};

export const LoginReducer = createAsyncThunk(
  "loginRedcer",
  async (obj, { dispatch }) => {
    try {
      const response = await LoginApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const OTPVerificationReducer = createAsyncThunk(
  "OTPVerificationReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await OTPVerificationApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const UserDetailReducer = createAsyncThunk(
  "UserDetailReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await UserDetailApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const getAllPackagesListReducer = createAsyncThunk(
  "getAllPackagesListReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await getAllPackagesListApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const EditProfileReducer = createAsyncThunk(
  "EditProfileReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await EditProfileApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const logoutReducer = createAsyncThunk(
  "logoutReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await logoutApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const allBookingsListReducer = createAsyncThunk(
  "allBookingsListReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await allBookingsListApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const bookInspectionReducer = createAsyncThunk(
  "bookInspectionReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await bookInspectionApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const allPropertiesReducer = createAsyncThunk(
  "allPropertiesReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await allPropertiesApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const BookingDetailReducer = createAsyncThunk(
  "BookingDetailReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await BookingDetailApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const BookingUpdateReducer = createAsyncThunk(
  "BookingUpdateReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await BookingUpdateApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);
export const AddLeadReducer = createAsyncThunk(
  "AddLeadReducer",
  async (obj, { dispatch }) => {
    try {
      const response = await AddLeadApi(obj);
      //console.log(response);
      return response;
    } catch (error) {
      toast.error(error.message);
    }
  }
);

export const MainSlice = createSlice({
  name: "mainSlice",
  initialState,
  reducers: {
    // clearDetail: (state, action) => {
    //   state.Batchesdetail = action?.payload;
    // },
  },
  extraReducers: {
    [UserDetailReducer.fulfilled]: (state, action) => {
      state.userDetail = action?.payload?.data;
    },
    [getAllPackagesListReducer.fulfilled]: (state, action) => {
      state.getAllPackagesList = action?.payload;
    },
    [allBookingsListReducer.fulfilled]: (state, action) => {
      state.allBookingsList = action?.payload;
    },
    [allPropertiesReducer.fulfilled]: (state, action) => {
      state.allProperties = action?.payload;
    },
    [BookingDetailReducer.fulfilled]: (state, action) => {
      state.BookingDetail = action?.payload?.data;
    },
  },
});

export const { clearDetail } = MainSlice.actions;

// export const { togglesuccess } = MainSlice.actions;

export default MainSlice.reducer;
